import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * @deprecated This service is deprecated and should not be used in new code. Use TkBackButtonComponent instead.
 */
@Injectable({
  providedIn: 'root',
})
export class BackButtonService {
  private route$ = new BehaviorSubject<string>('');

  setRoute(newRoute: string): void {
    this.route$.next(newRoute);
  }
}
